<template>
  <section
    id="testimonial"
    class="testimonial"
  >
    <div class="container">
        <VueSlickCarousel
          v-bind="slickOptions"
          v-if="!loadingTestimonial && testimonials.length > 0"
          v-vpshow-scroll="'slide-bottom'"
        >
          <div v-for="(testimonial, index) in testimonials" :key="index" class="card">
            <div class="feature-containers">
              <img
                :src="testimonial.image_jpg"
                class="card-img-top"
              />
              <div class="quote">
                <i class="fa fa-quote-left"></i>
              </div>
              <div class="testimonial-content" v-html="testimonial.testimonial"></div>
              <div class="rectangle"></div>
              <div class="testimonial-partner-name" v-html="testimonial.partner_name"></div>
              <div class="testimonial-title" v-html="testimonial.title"></div>
            </div>
          </div>
        </VueSlickCarousel>
        <div class="text-center" v-else-if="!loadingTestimonial && testimonials.length == 0"></div>
        <PaxelLoader :loading="loadingTestimonial"></PaxelLoader>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import PaxelLoader from '@/components/PaxelLoader.vue';

export default {
  name: 'Feature',
  components: {
    VueSlickCarousel,
    PaxelLoader,
  },
  data() {
    return {
      testimonials: [],
      loadingTestimonial: true,
      slickOptions: {
        arrows: false,
        dots: true,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 4,
        edgeFriction: 0.35,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$store.dispatch('fetchTestimonipage', {
      language: this.$store.getters.getLanguage,
      limit: 3,
      search_param: '',
      page: 1,
    });
  },
  created() {
    this.$store.watch(
      (state) => state.homepageTestimoni,
      (newValue) => {
        this.loadingTestimonial = true;
        this.testimonials = newValue;
        this.loadingTestimonial = false;
      },
    );
    this.$store.watch(
      (state) => state.language,
      (newValue) => {
        this.$store.dispatch('fetchTestimonipage', {
          language: newValue,
          limit: 3,
          earch_param: '',
          page: 1,
        });
      },
    );
  },
};
</script>
<style>
.mobile-home .testimonial {
  background-color: #f9f9fb;
}
.mobile-home .feature-containers {
  padding: 40px 10px 35px;
  background-color: #f9f9fb;
}
.mobile-home .testimonial-title {
  height: 44px;
  font-family: "GothamBook";
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: #ffb003;
}
.mobile-home .testimonial-partner-name {
  height: auto;
  margin: 20px 115px 10px 0;
  font-family: "GothamBook";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #424143;
}
.mobile-home .rectangle {
  height: 1px;
  background-color: #dedede;
}
.mobile-home .testimonial-content {
  height: 125px;
  font-family: "GothamBook";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: #424143;
  background-color: #f9f9fb;
}
.mobile-home .card:hover {
  z-index: 1000;
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
  -ms-transform: scale(0.95);
  -o-transform: scale(0.95);
  transform: scale(0.95);
  -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
}
.mobile-home .quote {
  margin: 15px 220px 24px 0;
  color: #5e51a1;
  font-size: 24px;
}
.mobile-home .feature-headline {
  text-align: center;
  font-family: "GothamBold";
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0px;
  font-weight: normal;
}
.mobile-home .feature-content {
  text-align: center;
  font-family: "GothamBook";
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0px;
  font-weight: normal;
}
.mobile-home .slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
  z-index: 1000;
}
.mobile-home .slick-dots li {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.mobile-home .slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: transparent;
}
.mobile-home .slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: #5e51a1;
}
.mobile-home .slick-dots li button:before {
  font-family: 'slick';
  font-size: 48px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: '•';
  text-align: center;
  opacity: 0.25;
  color: #5e51a1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.card > img {
  height: 252px;
  border-radius: 20px 20px 20px 20px;
  -webkit-transition: all 4s ease;
  -moz-transition: all 4s ease;
  -o-transition: all 4s ease;
  -ms-transition: all 4s ease;
  transition: all 4s ease;
}
.card-img-top {
  width: 100%;
  height: 262px;
  object-fit: cover;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.mobile-home .card {
  border: none;
  /*border-radius: 10px;*/
  overflow: hidden;
}
.mobile-home .card-body {
  height: 200px;
  padding: 30px 10px;
  overflow: hidden;
  word-wrap: break-word;
}
.mobile-home .card-body .card-text {
  font-family: "GothamMedium";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 32px;
  letter-spacing: normal;
  text-align: center;
  color: #424143;
}
</style>
<style scoped>
.mobile-home section .section-caption {
  padding-left: 15px;
}

.mobile-home .slick-custom-arrow {
  background: transparent;
  border: none;
  color: transparent;
  cursor: pointer;
  font-size: 24px;
  height: 100%;
  position: absolute;
  top: 0;
  transition-duration: 0.3s;
  z-index: 1000;
}
.mobile-home .slick-custom-arrow:hover {
  color: #575758;
  opacity: 1;
}
.mobile-home .slick-custom-arrow:focus {
  outline: none;
}
.mobile-home .slick-custom-arrow-left {
  left: -25px;
}
.mobile-home .slick-custom-arrow-right {
  right: -25px;
}
@-webkit-keyframes wobble-horizontal-on-hover {
  16.65% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  33.3% {
    -webkit-transform: translateX(-6px);
    transform: translateX(-6px);
  }
  49.95% {
    -webkit-transform: translateX(4px);
    transform: translateX(4px);
  }
  66.6% {
    -webkit-transform: translateX(-2px);
    transform: translateX(-2px);
  }
  83.25% {
    -webkit-transform: translateX(1px);
    transform: translateX(1px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes wobble-horizontal-on-hover {
  16.65% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  33.3% {
    -webkit-transform: translateX(-6px);
    transform: translateX(-6px);
  }
  49.95% {
    -webkit-transform: translateX(4px);
    transform: translateX(4px);
  }
  66.6% {
    -webkit-transform: translateX(-2px);
    transform: translateX(-2px);
  }
  83.25% {
    -webkit-transform: translateX(1px);
    transform: translateX(1px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
</style>
